export default {
    LOAD_SCHEDULE(state, schedule) {
        state.items = schedule;
    }
}
